import type { ChloromanceTheme } from '../../utils/Chloromance/types';

type TrackerHeroProps = {
  theme: ChloromanceTheme;
  remindersEnabled: boolean;
  notificationMessage: string;
  plantLimitMessage: string;
  cloudSyncMessage: string;
  allowMockUpgrade: boolean;
  onToggleTheme: () => void;
  onAddPlant: () => void;
  onOpenMockUpgrade: () => void;
  onToggleReminders: () => void;
  onOpenPrivacy?: () => void;
};

export function TrackerHero({
  theme,
  remindersEnabled,
  notificationMessage,
  plantLimitMessage,
  cloudSyncMessage,
  allowMockUpgrade,
  onToggleTheme,
  onAddPlant,
  onOpenMockUpgrade,
  onToggleReminders,
  onOpenPrivacy,
}: TrackerHeroProps) {
  return (
    <section className="chloromance-hero" aria-labelledby="chloromance-title">
      <div>
        <p className="chloromance-kicker">chloromance &amp; Hydration Engine</p>
        <h1 id="chloromance-title">Watering intelligence for every room, shelf, and sunny spot.</h1>
        <p>
          Timestamp-driven care tracking with live soil moisture, location logging, and local-first
          persistence for indoor plants, patios, and chloromance shelves.
        </p>
      </div>
      <div className="chloromance-actions">
        <button className="theme-mode-toggle" type="button" onClick={onToggleTheme} aria-pressed={theme === 'dark'}>
          {theme === 'dark' ? 'Light Mode' : 'Dark Mode'}
        </button>
        <button className="primary-action" type="button" onClick={onAddPlant}>Add Plant</button>
        {allowMockUpgrade && (
          <button className="upgrade-action" type="button" onClick={onOpenMockUpgrade}>
            Upgrade Plan
          </button>
        )}
        <button
          className={`reminder-toggle ${remindersEnabled ? 'is-on' : ''}`}
          type="button"
          onClick={onToggleReminders}
          aria-pressed={remindersEnabled}
        >
          <span aria-hidden="true" />
          Enable WiltPower
        </button>
        <button className="privacy-page-link" type="button" onClick={onOpenPrivacy}>Privacy Policy</button>
        {notificationMessage && <small>{notificationMessage}</small>}
        {plantLimitMessage && <small className="plant-limit-message">{plantLimitMessage}</small>}
        {cloudSyncMessage && <small>{cloudSyncMessage}</small>}
      </div>
    </section>
  );
}
